<form *ngIf="paystub" class="app-grid" #form="ngForm" autocomplete="off">
    <div *ngIf="!hasActiveIncomeTypes; else displayInsurableHoursFormView">
        <app-empty-state
            label="forms.insurable-hours-form.thereAreNoIncomeTypesSetupForThisCompany"
            src="/assets/illustrations/piggy-bank.png"
        ></app-empty-state>
    </div>
    <ng-template #displayInsurableHoursFormView>
        <!-- Hourly Employees -->
        <div *ngIf="paystub?.hourlyEmployee; else displaySalariedInsurableHoursForm">
            <ng-container *ngIf="insurableHourlyPayItems && insurableHourlyPayItems.length > 0">
                <ui-banner *ngIf="displayInsurableHoursErrorString" variant="warning" class="margin-bottom-3">
                    <p>
                        <strong>{{ insurableHoursErrorString }}</strong>
                    </p>
                </ui-banner>
                <h3 class="margin-bottom-4 margin-top-1">
                    {{ 'forms.insurable-hours-form.incomeTypesBasedOnTheRegularHourlyRate' | translate }}
                </h3>
                <table class="ui table insurable-hourly-table">
                    <thead>
                        <tr>
                            <th>{{ 'forms.insurable-hours-form.name' | translate }}</th>
                            <th>{{ 'forms.insurable-hours-form.hourlyRate' | translate }}</th>
                            <th>{{ 'forms.insurable-hours-form.hours' | translate }}</th>
                            <th>{{ 'forms.insurable-hours-form.subtotal' | translate }}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <ng-container *ngFor="let insurableHoursPayItemGroup of insurableHourlyPayItems">
                            <tr
                                *ngFor="let payItem of insurableHoursPayItemGroup.payItems; let i = index"
                                [ngClass]="{ 'first-pay-item-instance-per-rate': i === 0 }"
                            >
                                <td *ngIf="i === 0; else displayNoAdditionalPayItemName">
                                    {{ insurableHoursPayItemGroup.name }}
                                    <ng-container *ngIf="payItem.reduceVacationPayBalance">
                                        <span
                                            class="pay-item-balance {{
                                                remainingVacationPayBalance < 0 ? 'warning' : ''
                                            }}"
                                            >{{ 'forms.insurable-hours-form.balance' | translate }}
                                            {{ remainingVacationPayBalance | i18nNum: '$' }}</span
                                        >
                                    </ng-container>
                                </td>
                                <ng-template #displayNoAdditionalPayItemName>
                                    <td>&nbsp;</td>
                                </ng-template>
                                <td>
                                    {{ payItem.rateMultiplied | i18nNum: '$' : { minDecimal: 0, maxDecimal: 4 } }}
                                    <span *ngIf="payItem.multiplier !== 1.0">({{ payItem.multiplier | number }}x)</span>
                                </td>
                                <td>
                                    <mat-form-field class="insurable-hours-form-field">
                                        <input
                                            matInput
                                            [name]="'hours-amount-' + payItem.name + '-' + payItem.compensationId"
                                            [disabled]="payItem.employeeHoursExists"
                                            [ngModel]="getFormattedHours(payItem)"
                                            (ngModelChange)="
                                                setFormattedHours(payItem, $event, insurableHoursPayItemGroup)
                                            "
                                            #hours="ngModel"
                                            type="text"
                                            [textMask]="{ mask: twoDecimalPointsNumberMask }"
                                            [min]="0"
                                            [max]="744"
                                        />
                                        <mat-error *ngIf="hours.invalid">{{ hours.errors | formErrors }}</mat-error>
                                    </mat-form-field>
                                </td>
                                <td>{{ payItem.amount | i18nNum: '$' }}</td>
                            </tr>
                        </ng-container>
                    </tbody>
                </table>
            </ng-container>
            <ng-container *ngIf="insurableDollarPayItems && insurableDollarPayItems.length > 0">
                <h3 class="margin-bottom-4">
                    {{ 'forms.insurable-hours-form.incomeTypesWithAdollarAmount' | translate }}
                </h3>
                <table class="ui table insurable-dollar-table">
                    <thead>
                        <tr>
                            <th>{{ 'forms.insurable-hours-form.name' | translate }}</th>
                            <th>{{ 'forms.insurable-hours-form.frequency' | translate }}</th>
                            <th>&nbsp;</th>
                            <th>{{ 'forms.insurable-hours-form.subtotal' | translate }}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let insurableDollarPayItemGroup of insurableDollarPayItems">
                            <td>
                                {{ insurableDollarPayItemGroup.payItem.displayName }}
                                <ng-container *ngIf="insurableDollarPayItemGroup.payItem.reduceVacationPayBalance">
                                    <span
                                        class="pay-item-balance {{ remainingVacationPayBalance < 0 ? 'warning' : '' }}"
                                        >{{ 'forms.insurable-hours-form.balance' | translate }}
                                        {{ remainingVacationPayBalance | currency }}</span
                                    >
                                </ng-container>
                            </td>
                            <td>{{ insurableDollarPayItemGroup.frequency | appTranslateOptions: frequencyOptions }}</td>
                            <td>&nbsp;</td>
                            <td>
                                <mat-form-field>
                                    <input
                                        matInput
                                        [name]="'dollar-amount-' + insurableDollarPayItemGroup.payItem.name"
                                        [ngModel]="insurableDollarPayItemGroup.payItem.amount"
                                        (ngModelChange)="
                                            setFormattedAmount(insurableDollarPayItemGroup.payItem, $event)
                                        "
                                        #amount="ngModel"
                                        type="text"
                                        [textMask]="{ mask: currencyMask }"
                                        [min]="0"
                                    />
                                    <mat-error *ngIf="amount.invalid">{{ amount.errors | formErrors }}</mat-error>
                                </mat-form-field>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </ng-container>
        </div>
        <!-- Salaried Employees -->
        <ng-template #displaySalariedInsurableHoursForm>
            <ng-container *ngIf="insurableHourlyPayItems && insurableHourlyPayItems.length > 0">
                <ui-banner *ngIf="displayInsurableHoursErrorString" variant="warning" class="margin-bottom-3">
                    <p>
                        <strong>{{ insurableHoursErrorString }}</strong>
                    </p>
                </ui-banner>
                <h3 class="margin-bottom-4 margin-top-1">
                    {{ 'forms.insurable-hours-form.incomeTypesBasedOnTheRegularHourlyRate' | translate }}
                </h3>
                <table class="ui table insurable-hourly-table">
                    <thead>
                        <tr>
                            <th>{{ 'forms.insurable-hours-form.name' | translate }}</th>
                            <th>{{ 'forms.insurable-hours-form.hourlyRate' | translate }}</th>
                            <th>{{ 'forms.insurable-hours-form.hours' | translate }}</th>
                            <th>{{ 'forms.insurable-hours-form.subtotal' | translate }}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <!-- Recurring Payroll -->
                        <ng-container *ngIf="payroll?.recurring; else displayOffCycleInsurableHourlyPayItems">
                            <ng-container *ngFor="let insurableHoursPayItemGroup of insurableHourlyPayItems">
                                <tr
                                    *ngFor="let payItem of insurableHoursPayItemGroup.payItems; let i = index"
                                    [ngClass]="{ 'first-pay-item-instance-per-rate': i === 0 }"
                                >
                                    <td *ngIf="i === 0; else displayNoAdditionalPayItemName">
                                        {{ insurableHoursPayItemGroup.name }}
                                        <ng-container *ngIf="payItem.reduceVacationPayBalance">
                                            <span
                                                class="pay-item-balance {{
                                                    remainingVacationPayBalance < 0 ? 'warning' : ''
                                                }}"
                                                >{{ 'forms.insurable-hours-form.balance' | translate }}
                                                {{ remainingVacationPayBalance | i18nNum: '$' }}</span
                                            >
                                        </ng-container>
                                        <ng-container *ngIf="payItem.name === 'unpaid_time_off_salaried'">
                                            <br />
                                            <span
                                                class="pay-item-balance"
                                                [class.warning]="payItem.amountWithoutMultiplier > 0"
                                                >{{
                                                    'forms.insurable-hours-form.reducingSalaryBy'
                                                        | translate
                                                            : { amount: payItem.amountWithoutMultiplier | i18nNum: '$' }
                                                }}</span
                                            >
                                        </ng-container>
                                    </td>
                                    <ng-template #displayNoAdditionalPayItemName>
                                        <td>&nbsp;</td>
                                    </ng-template>
                                    <td>
                                        {{ payItem.rateMultiplied | i18nNum: '$' : { minDecimal: 0, maxDecimal: 4 } }}
                                        <span *ngIf="payItem.multiplier !== 1.0"
                                            >({{ payItem.multiplier | i18nNum: 'no$' }}x)</span
                                        >
                                    </td>
                                    <td>
                                        <mat-form-field class="insurable-hours-form-field">
                                            <input
                                                matInput
                                                [name]="'hours-amount-' + payItem.name + '-' + payItem.compensationId"
                                                [disabled]="payItem.employeeHoursExists"
                                                [ngModel]="getFormattedHours(payItem)"
                                                (ngModelChange)="
                                                    setFormattedHours(payItem, $event, insurableHoursPayItemGroup)
                                                "
                                                #hours="ngModel"
                                                type="text"
                                                [textMask]="{ mask: twoDecimalPointsNumberMask }"
                                                [min]="0"
                                                [max]="744"
                                            />
                                            <mat-error *ngIf="hours.invalid">{{ hours.errors | formErrors }}</mat-error>
                                        </mat-form-field>
                                    </td>
                                    <td>{{ payItem.amount | i18nNum: '$' }}</td>
                                </tr>
                            </ng-container>
                        </ng-container>
                        <!-- Off-Cycle Payroll -->
                        <ng-template #displayOffCycleInsurableHourlyPayItems>
                            <ng-container *ngFor="let insurableHoursPayItemGroup of insurableHourlyPayItems">
                                <ng-container
                                    *ngFor="let payItem of insurableHoursPayItemGroup.payItems; let i = index"
                                >
                                    <tr
                                        *ngIf="!payItem.subtractFromSalary"
                                        [ngClass]="{ 'first-pay-item-instance-per-rate': i === 0 }"
                                    >
                                        <td *ngIf="i === 0; else displayNoAdditionalPayItemName">
                                            {{ insurableHoursPayItemGroup.name }}
                                            <span *ngIf="payItem.subtractFromSalary">{{
                                                'forms.insurable-hours-form.subtractableOffcycle' | translate
                                            }}</span>
                                            <ng-container *ngIf="payItem.reduceVacationPayBalance">
                                                <span
                                                    class="pay-item-balance {{
                                                        remainingVacationPayBalance < 0 ? 'warning' : ''
                                                    }}"
                                                    >{{ 'forms.insurable-hours-form.balance' | translate }}
                                                    {{ remainingVacationPayBalance | i18nNum: '$' }}</span
                                                >
                                            </ng-container>
                                        </td>
                                        <ng-template #displayNoAdditionalPayItemName>
                                            <td>&nbsp;</td>
                                        </ng-template>
                                        <td>
                                            ${{
                                                payItem.rateMultiplied | i18nNum: '$' : { minDecimal: 0, maxDecimal: 4 }
                                            }}
                                            <span *ngIf="payItem.multiplier !== 1.0"
                                                >({{ payItem.multiplier | i18nNum: 'no$' }}x)</span
                                            >
                                        </td>
                                        <td>
                                            <mat-form-field class="insurable-hours-form-field">
                                                <input
                                                    matInput
                                                    [name]="
                                                        'hours-amount-' + payItem.name + '-' + payItem.compensationId
                                                    "
                                                    [disabled]="payItem.employeeHoursExists"
                                                    [ngModel]="getFormattedHours(payItem)"
                                                    (ngModelChange)="
                                                        setFormattedHours(payItem, $event, insurableHoursPayItemGroup)
                                                    "
                                                    #hours="ngModel"
                                                    type="text"
                                                    [textMask]="{ mask: twoDecimalPointsNumberMask }"
                                                    [min]="0"
                                                    [max]="744"
                                                />
                                                <mat-error *ngIf="hours.invalid">{{
                                                    hours.errors | formErrors
                                                }}</mat-error>
                                            </mat-form-field>
                                        </td>
                                        <td>{{ payItem.amount | i18nNum: '$' }}</td>
                                    </tr>
                                </ng-container>
                            </ng-container>
                        </ng-template>
                    </tbody>
                </table>
            </ng-container>
            <h3>{{ 'forms.insurable-hours-form.incomeTypesWithAdollarAmount' | translate }}</h3>
            <table class="ui table insurable-dollar-table">
                <thead>
                    <tr>
                        <th>{{ 'forms.insurable-hours-form.name' | translate }}</th>
                        <th>{{ 'forms.insurable-hours-form.frequency' | translate }}</th>
                        <th>&nbsp;</th>
                        <th>{{ 'forms.insurable-hours-form.subtotal' | translate }}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let insurableDollarPayItemGroup of insurableDollarPayItems">
                        <td>
                            {{ insurableDollarPayItemGroup.payItem.displayName }}
                            <ng-container *ngIf="insurableDollarPayItemGroup?.payItem?.reduceVacationPayBalance">
                                <span class="pay-item-balance {{ remainingVacationPayBalance < 0 ? 'warning' : '' }}"
                                    >{{ 'forms.insurable-hours-form.balance' | translate }}
                                    {{ remainingVacationPayBalance | i18nNum: '$' }}</span
                                >
                            </ng-container>
                        </td>
                        <td>{{ insurableDollarPayItemGroup.frequency | appTranslateOptions: frequencyOptions }}</td>
                        <td>&nbsp;</td>
                        <td>
                            <mat-form-field>
                                <input
                                    matInput
                                    [name]="'dollar-amount-' + insurableDollarPayItemGroup.payItem.name"
                                    [ngModel]="insurableDollarPayItemGroup.payItem.amount"
                                    (ngModelChange)="setFormattedAmount(insurableDollarPayItemGroup.payItem, $event)"
                                    #amount="ngModel"
                                    type="text"
                                    [textMask]="{ mask: currencyMask }"
                                    [min]="0"
                                />
                                <mat-error *ngIf="amount.invalid">{{ amount.errors | formErrors }}</mat-error>
                            </mat-form-field>
                        </td>
                    </tr>
                </tbody>
            </table>
        </ng-template>
    </ng-template>
</form>
